export class uploadPojo {
    id:string |any;
    name:string|any;
    type:string|any;
    filePath:string|any;
    // slideid:string|any;
}